import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IGlobalState } from '../types';
import { getContent } from '../../service/api';
import { IGetProfileDetail } from '../../interfaces/repositories';

const isAuth: string =
  typeof window !== 'undefined' &&
  localStorage.getItem('accessToken') !== null &&
  localStorage.getItem('accessToken') !== '' &&
  localStorage.getItem('accessToken') !== undefined
    ? localStorage.getItem('accessToken')!
    : '';

const storageProfile: string | null =
  typeof window !== 'undefined' &&
  localStorage.getItem('profile') !== null &&
  localStorage.getItem('profile') !== '' &&
  localStorage.getItem('profile') !== undefined
    ? localStorage.getItem('profile')!
    : null;

// viewMod : 0 - standart, 1 - fullscreen

const initialState: IGlobalState = {
  viewMod: 0,
  flutterReady: 0,
  platform: null, // mobile , web
  isAndroid: false,
  auth: isAuth !== '',
  token: isAuth,
  profile: storageProfile !== null ? JSON.parse(storageProfile) : null,
  fcm_token: '',
  recaptchaToken: null,
  content: null,
  pending: false,
  error: null,
  kaspiOrderId: null,
};

export const appGlobalSlice = createSlice({
  name: 'appGlobal',
  initialState,
  reducers: {
    viewModFullScreen: (state: Draft<IGlobalState>) => {
      state.viewMod = 1;
    },

    viewModStandart: (state: Draft<IGlobalState>) => {
      state.viewMod = 0;
    },

    setFlutterReady: (
      state: Draft<IGlobalState>,
      action: PayloadAction<number>
    ) => {
      state.flutterReady = action.payload;
    },

    setAndroidPlatform: (
      state: Draft<IGlobalState>,
      action: PayloadAction<boolean>
    ) => {
      state.isAndroid = action.payload;
    },

    setPlatformRedux: (
      state: Draft<IGlobalState>,
      action: PayloadAction<string>
    ) => {
      state.platform = action.payload;
    },

    setAuth: (state: Draft<IGlobalState>, action: PayloadAction<boolean>) => {
      state.auth = action.payload;
    },

    setRecapchaToken: (
      state: Draft<IGlobalState>,
      action: PayloadAction<string | null>
    ) => {
      state.recaptchaToken = action.payload;
    },

    setProfile: (
      state: Draft<IGlobalState>,
      action: PayloadAction<IGetProfileDetail>
    ) => {
      state.profile = action.payload;
      localStorage.setItem('profile', JSON.stringify(action.payload));
    },

    setToken: (state: Draft<IGlobalState>, action: PayloadAction<string>) => {
      state.token = action.payload;
      localStorage.setItem('accessToken', action.payload);
    },

    setFcmToken: (
      state: Draft<IGlobalState>,
      action: PayloadAction<string>
    ) => {
      state.fcm_token = action.payload;
    },

    logOut: (state) => {
      state.token = '';
      localStorage.removeItem('accessToken');
      localStorage.removeItem('profile');
      state.auth = false;
    },

    setKaspiOrderId: (
      state: Draft<IGlobalState>,
      action: PayloadAction<string>
    ) => {
      state.kaspiOrderId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContent.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getContent.fulfilled, (state, action) => {
        state.content = action.payload;
        state.pending = false;
      })
      .addCase(getContent.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export const {
  setPlatformRedux,
  setAndroidPlatform,
  setRecapchaToken,
  viewModFullScreen,
  viewModStandart,
  setFlutterReady,
  setAuth,
  setToken,
  setProfile,
  setKaspiOrderId,
  logOut,
  setFcmToken,
} = appGlobalSlice.actions;
export default appGlobalSlice.reducer;
